export default function isPaidSingleUseOptionUtil (option) {
  return /single use/i.test(option)
}
